<template>
  <div :data-testid="`${dataTestId}-section`">
    <div v-if="title" class="mt-4" :data-testid="`${dataTestId}-title`">
      <h2
        class="font-montserrat font-[16px] font-bold text-university-primary mb-2"
      >
        {{ title }}
      </h2>
      <hr class="border-t border-gray-475 mb-2" />
    </div>
    <ul class="space-y-2" :data-testid="`${dataTestId}-list`">
      <slot name="sidebarItems">
        <SidebarItem
          v-for="(item, index) in props.items"
          :key="index"
          :text="item.text"
          :router-link="item.routerLink"
          :mui-icon-name="item.muiIconName"
          :href="item.href"
          :data-test-id="`${dataTestId}-item-${index}`"
          @menu-item-clicked="handleMenuItemClick"
        >
          <template #icon>
            <component :is="item.icon" fill="#1E2648" />
          </template>
        </SidebarItem>
      </slot>
    </ul>
  </div>
</template>

<script setup>
import SidebarItem from "./SidebarItem.vue";

const emit = defineEmits(["menu-item-clicked"]);

const handleMenuItemClick = () => {
  emit("menu-item-clicked");
};

const props = defineProps({
  title: {
    type: String,
    required: false,
  },
  items: {
    type: Array,
    required: false,
    default: [],
  },
  dataTestId: {
    type: String,
    required: true,
  },
});
</script>
